import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { SnackbarContext } from "components/context/SnackbarProvider";

const path = `${baseUrl}/note`;
const keyName = "Note";

export const {
  useGetAll: useAllNote,
  useGet: useGetNote,
  useCreate: useCreateNote,
  useUpdate: useUpdateNote,
  useDelete: useDeleteNote,
} = apiCrudBuilder(path, keyName);

export const useFinalizePause = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);
  const { displayError } = useContext(SnackbarContext);

  return useMutation({
    ...options,
    mutationFn: (noteId) =>
      appAxios
        .post(`${path}/${noteId}/finalize_pause/`)
        .then((res) => res.data),
    onSuccess: (data, noteId) => {
      queryClient.invalidateQueries({ queryKey: [keyName, `${noteId}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${keyName}`] });
    },
    onError: displayError,
  });
};

export const useFinalizeComplete = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (noteId) =>
      appAxios
        .post(`${path}/${noteId}/finalize_complete/`)
        .then((res) => res.data),
    onSuccess: (data, noteId) => {
      queryClient.invalidateQueries({ queryKey: [keyName, `${noteId}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${keyName}`] });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useFinalizeAuto = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (noteId) =>
      appAxios.post(`${path}/${noteId}/finalize_auto/`).then((res) => res.data),
    onSuccess: (data, noteId) => {
      queryClient.invalidateQueries({ queryKey: [keyName, `${noteId}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${keyName}`] });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useFinalizeNever = (options) => {
  const queryClient = useQueryClient();
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (noteId) =>
      appAxios
        .post(`${path}/${noteId}/finalize_never/`)
        .then((res) => res.data),
    onSuccess: (data, noteId) => {
      queryClient.invalidateQueries({ queryKey: [keyName, `${noteId}`] });
      queryClient.invalidateQueries({ queryKey: [`all_${keyName}`] });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
